import { Button } from '@mui/material';
import styled from 'styled-components';

import { SYNMATCH_RADII } from 'theme';

export const PublicStateButton = styled(Button).attrs({
  color: 'primary',
  disableRipple: true,
  variant: 'contained',
})`
  && {
    padding-block: 0.65rem;
    padding-inline: 1.4rem;
    font-size: 0.95rem;
    font-weight: 520;
    border-radius: ${SYNMATCH_RADII.md};

    .MuiSvgIcon-root {
      font-size: 1.05rem;
      transition: transform 160ms cubic-bezier(0.2, 0, 0.2, 1);
    }

    &:hover .MuiSvgIcon-root {
      transform: translateX(0.1875rem);
    }
  }
`;
